// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TerapeutCard_cardContainer__T97w\\+ {
  padding: 8px;
  border-radius: 8px;
  border: 2px solid #ccc;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 450px;
  width: 100%;
  max-width: 230px;
}

.TerapeutCard_profilePicContainer__RPE4F {
  position: relative;
  width: 100%;
  min-height: 280px;
}

.TerapeutCard_cardContainer__T97w\\+:hover {
  border: 2px solid #5f6d7e;
  transition: border 300ms ease-in-out;
  cursor: pointer;
}

.TerapeutCard_profilePic__7\\+1FL {
  border-radius: 4px;
  width: 100%;
  height: 100%;
}
.TerapeutCard_roleLabel__MK7U8 {
  position: absolute;
  bottom: 4px;
  right: 0;
  background-color: #cb9c2d;
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-family: "Inter";
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: -0.001em;
  text-align: left;
}

.TerapeutCard_textRow__es2-i {
  margin: 8px 0;
  font-family: "Inter";
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  color: #4d4d4d;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
}
.TerapeutCard_rowContainer__gaWXI {
  display: flex;
}
.TerapeutCard_name__Zq43a {
  font-family: "Inter";
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  color: #4d4d4d;
}

@media screen and (max-width: 550px) {
  .TerapeutCard_cardContainer__T97w\\+ {
    max-width: 190px;
    height: 350px;
  }
}

@media screen and (max-width: 490px) {
  .TerapeutCard_cardContainer__T97w\\+ {
    box-sizing: border-box;
  }
}

@media screen and (max-width: 450px) {
  .TerapeutCard_cardContainer__T97w\\+ {
    max-width: 160px;
    height: 315px;
  }
  .TerapeutCard_textRow__es2-i {
    font-size: 13px;
  }
  .TerapeutCard_name__Zq43a {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/terapeuti/components/TerapeutCard.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".cardContainer {\n  padding: 8px;\n  border-radius: 8px;\n  border: 2px solid #ccc;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 450px;\n  width: 100%;\n  max-width: 230px;\n}\n\n.profilePicContainer {\n  position: relative;\n  width: 100%;\n  min-height: 280px;\n}\n\n.cardContainer:hover {\n  border: 2px solid #5f6d7e;\n  transition: border 300ms ease-in-out;\n  cursor: pointer;\n}\n\n.profilePic {\n  border-radius: 4px;\n  width: 100%;\n  height: 100%;\n}\n.roleLabel {\n  position: absolute;\n  bottom: 4px;\n  right: 0;\n  background-color: #cb9c2d;\n  color: #fff;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-family: \"Inter\";\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 17px;\n  letter-spacing: -0.001em;\n  text-align: left;\n}\n\n.textRow {\n  margin: 8px 0;\n  font-family: \"Inter\";\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  letter-spacing: 0em;\n  text-align: left;\n  color: #4d4d4d;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  -webkit-line-clamp: 1;\n  text-overflow: ellipsis;\n}\n.rowContainer {\n  display: flex;\n}\n.name {\n  font-family: \"Inter\";\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  text-align: left;\n  color: #4d4d4d;\n}\n\n@media screen and (max-width: 550px) {\n  .cardContainer {\n    max-width: 190px;\n    height: 350px;\n  }\n}\n\n@media screen and (max-width: 490px) {\n  .cardContainer {\n    box-sizing: border-box;\n  }\n}\n\n@media screen and (max-width: 450px) {\n  .cardContainer {\n    max-width: 160px;\n    height: 315px;\n  }\n  .textRow {\n    font-size: 13px;\n  }\n  .name {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardContainer": `TerapeutCard_cardContainer__T97w+`,
	"profilePicContainer": `TerapeutCard_profilePicContainer__RPE4F`,
	"profilePic": `TerapeutCard_profilePic__7+1FL`,
	"roleLabel": `TerapeutCard_roleLabel__MK7U8`,
	"textRow": `TerapeutCard_textRow__es2-i`,
	"rowContainer": `TerapeutCard_rowContainer__gaWXI`,
	"name": `TerapeutCard_name__Zq43a`
};
export default ___CSS_LOADER_EXPORT___;
